import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { Text } from '@atlaskit/primitives/compiled/text';

import messages from './messages';

export const PublishMigrationModal = ({
	isOpen,
	onCancel,
	onConfirm,
}: {
	isOpen: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const hasConfirmedRef = React.useRef(false);

	React.useEffect(() => {
		if (isOpen) {
			hasConfirmedRef.current = false;
		}
	}, [isOpen]);

	const handleConfirm = () => {
		if (hasConfirmedRef.current) {
			return;
		}

		hasConfirmedRef.current = true;
		onConfirm();
	};

	return (
		<ModalTransition>
			{isOpen && (
				<Modal width="small" onClose={onCancel}>
					<ModalHeader hasCloseButton>
						<ModalTitle>{formatMessage(messages.title)}</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<Text as="p">{formatMessage(messages.body)}</Text>
					</ModalBody>
					<ModalFooter>
						<Button appearance="subtle" onClick={onCancel}>
							{formatMessage(messages.keepEditing)}
						</Button>
						<Button appearance="primary" onClick={handleConfirm}>
							{formatMessage(messages.publish)}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
